<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <convenio-list
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"

            />
        </template>

         <add-button v-if="$store.getters.hasPermission('CONVENIO_CREATE') && $store.getters.hasPermission('CONVENIO_SHOW')" @click="create"></add-button>

        <convenio-create v-if="creating"
                        :open="creating"
                        v-on:itemCreated="onItemCreated"
                        v-on:close="creating=false"
        />

        <convenio-update v-if="updating"
                        :open="updating"
                        :item="itemToEdit"
                        v-on:itemUpdated="onItemUpdated"
                        v-on:close="updating=false"
        />

        <convenio-show v-if="showing"
                           :open="showing"
                           :item="itemToShow"
                           v-on:close="showing=false"
         />

        <convenio-delete v-if="deleting"
                         :open="deleting"
                         :item="itemToDelete"
                         v-on:itemDeleted="onItemDeleted"
                         v-on:close="deleting=false"
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>

    import ConvenioCreate from "./ConvenioCreate";
    import ConvenioUpdate from "./ConvenioUpdate";
    import ConvenioDelete from "./ConvenioDelete";
    import ConvenioShow from "./ConvenioShow";
    import ConvenioList from "./ConvenioList";

     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

    export default {
        name: "ConvenioCrudPage",
        components: {
            CrudLayout, AddButton, Snackbar,
            ConvenioCreate,
            ConvenioUpdate,
            ConvenioDelete,
            ConvenioShow,
            ConvenioList
        },
        data() {
            return {
                title: 'cobrox.convenio.title',
                subtitle: 'cobrox.convenio.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }

    }
</script>


